export default {
  backmarketId: {
    id: 'listings_create_backmarket_id',
    defaultMessage: 'Back Market ID: {id, html}',
  },
  productId: {
    id: 'listings_create_product_id',
    defaultMessage: 'Product ID: {id, html}',
  },
  manufacturerVersion: {
    id: 'listings_create_manufacturer_version',
    defaultMessage: 'Manufacturer Version: {manufacturerVersion, html}',
  },
  mpn: {
    id: 'listings_create_mpn',
    defaultMessage: 'MPN: {mpn, html}',
  },
  alternativeControllerText: {
    id: 'listings_create_alternative_controller_text',
    defaultMessage: 'Controller',
  },
  alternativeCurrentText: {
    id: 'listings_create_alternative_current_text',
    defaultMessage: 'Current slide',
  },
  generalInfos: {
    id: 'listings_create_general_infos',
    defaultMessage: 'General infos',
  },
  aestheticCondition: {
    id: 'listings_create_aesthetic_condition',
    defaultMessage: 'Aesthetic condition',
  },
  learnMore: {
    id: 'listings_create_learn_more',
    defaultMessage: 'Learn more',
  },
  sku: {
    id: 'listings_create_sku',
    defaultMessage: 'SKU (unique offer ID)',
  },
  stock: {
    id: 'listings_create_stock',
    defaultMessage: 'Stock',
  },
  price: {
    id: 'listings_create_price',
    defaultMessage: 'Price',
  },
  market: {
    id: 'listings_create_table_market',
    defaultMessage: 'Market',
  },
  myPrice: {
    id: 'listings_create_table_price',
    defaultMessage: 'My price',
  },
  priceInput: {
    id: 'listings_create_price_input',
    defaultMessage: 'Price ({currency})',
  },
  warranty: {
    id: 'listing_create_warranty',
    defaultMessage: 'Warranty',
  },
  warrantyDescription: {
    id: 'listing_create_warranty_description',
    defaultMessage:
      'The minimum warranty period will automatically be applied to this listing. You can increase the warranty period on the listing detail view.',
  },
  required: {
    id: 'listing_create_required',
    defaultMessage: 'This field is required',
  },
  priceError: {
    id: 'listing_create_price_error',
    defaultMessage: 'You need to fill at least one price in the table.',
  },
  priceValueError: {
    id: 'listing_create_price_value_error',
    defaultMessage: 'Price should be greater than zero',
  },
  stockError: {
    id: 'listing_create_stock_error',
    defaultMessage: 'The stock has to be greater or equal than {minimum}',
  },
  saveMyListing: {
    id: 'listing_create_save_listing',
    defaultMessage: 'Save my listing',
  },
  saveMyListingAndCreateNewOne: {
    id: 'listing_create_save_listing_and_create_another',
    defaultMessage: 'Save my listing and create a new one',
  },
  errorOnListingCreationToastTitle: {
    id: 'listing_creation_error_on_submit_toast_title',
    defaultMessage: 'Oops!',
  },
  backboxPrice: {
    id: 'listings_buybox_price',
    defaultMessage: 'Buybox price',
  },
  currentBMPrice: {
    id: 'listings_current_bm_price',
    defaultMessage: 'Current BM price',
  },
  getBackbox: {
    id: 'listings_create_get_buybox',
    defaultMessage: 'Get buybox',
  },
  getAllBackbox: {
    id: 'listings_create_get_all_buybox',
    defaultMessage: 'Get all buybox',
  },
  newBatteryToggleTitle: {
    id: 'listings_create_new_battery_toggle_title',
    defaultMessage: 'Supercharged with new battery',
  },
  newBatteryToggleContent: {
    id: 'listings_create_new_battery_toggle_content',
    defaultMessage:
      'Select only if you’ve installed new batteries with 100% capacity in all items within this listing. {link, html}',
  },
  newBatteryToggleContentLink: {
    id: 'listings_create_new_battery_toggle_content_link',
    defaultMessage: 'Read this article for more details',
  },
  noCompetitionTitle: {
    id: 'listings_create_winner_price_cell_no_competition_title',
    defaultMessage: '[No competition]',
  },
  noCompetitionInfo: {
    id: 'listings_create_winner_price_cell_no_competition_info',
    defaultMessage:
      '[No competition on this listing in this market, you will have the BackBox if you add this listing in this country.]',
  },
  loadingText: {
    id: 'listings_create_loading_text',
    defaultMessage: 'Loading product...',
  },
}
